import { useCallback, useState } from "react";
import api from "../services/api";
import { RECON } from "../services/apiConstant";
import { compressImagesForAI } from "../utils/imageCompression";

const HEIC_EXTENSIONS = [".heic", ".heif"];

function isImageFile(file: File): boolean {
  if (file.type.startsWith("image/")) return true;
  const lower = file.name.toLowerCase();
  return HEIC_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

export function useAIPhotoDescription() {
  const [isLoading, setIsLoading] = useState(false);

  // Stable reference — safe to use as useEffect dependency
  const generateDescription = useCallback(async (files: File[]): Promise<string> => {
    const imageFiles = files.filter(isImageFile);
    if (imageFiles.length === 0) throw new Error("No image files provided.");

    setIsLoading(true);
    try {
      const compressed = await compressImagesForAI(imageFiles);

      const formData = new FormData();
      for (const file of compressed) {
        formData.append("files", file);
      }

      const response = await api.post<{ description: string }>(
        RECON.describePhotos,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return response.data.description;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { generateDescription, isLoading };
}

export { isImageFile };
